import React from 'react';
import { OfficialTableCell } from '../print/OfficialReportLayout';
import { RelatorioEmendaSecretariaStatusItem } from '../../services/reportService';
import { fMoney } from '../../utils/emendaFormatters';

interface ReportResumoTableProps {
  data: RelatorioEmendaSecretariaStatusItem[];
}

const ReportResumoTable: React.FC<ReportResumoTableProps> = ({ data }) => {
  if (data.length === 0) {
    return (
      <div className="rounded-xl border border-slate-200 px-4 py-10 text-center text-sm text-slate-500 dark:border-slate-700 dark:text-slate-400">
        Nenhum agrupamento disponível para os filtros atuais.
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 dark:border-slate-700">
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr>
              <OfficialTableCell head>Secretaria</OfficialTableCell>
              <OfficialTableCell head>Etapa</OfficialTableCell>
              <OfficialTableCell head align="right">Quantidade</OfficialTableCell>
              <OfficialTableCell head align="right">Valor total</OfficialTableCell>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={`${item.secretariaDestino || ''}-${item.statusCicloVida || ''}-${index}`}>
                <OfficialTableCell>{item.secretariaDestino || 'Não informada'}</OfficialTableCell>
                <OfficialTableCell>{item.statusCicloVida || 'Sem etapa'}</OfficialTableCell>
                <OfficialTableCell align="right">{item.quantidade}</OfficialTableCell>
                <OfficialTableCell align="right">{fMoney(item.valorTotal)}</OfficialTableCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportResumoTable;
